import { useMemo } from 'react';

import { hasValidCoordinates } from 'shared/utils';
import type { LatLng } from '../../shared/types';
import { Map } from '../../features/mapping/components/Map';

export type UseDefaultMapCenterOptions = {
  geoEvent?: LatLng;
  initialLat?: number;
  initialLng?: number;
};

export const useDefaultMapCenter = (
  options: UseDefaultMapCenterOptions,
): LatLng => {
  const { geoEvent, initialLat, initialLng } = options;

  return useMemo(() => {
    const geoEventCoords = {
      lat: geoEvent?.lat,
      lng: geoEvent?.lng,
    };

    if (hasValidCoordinates(geoEventCoords)) {
      return { lat: geoEventCoords.lat, lng: geoEventCoords.lng };
    }

    const initialCoords = {
      lat: initialLat,
      lng: initialLng,
    };

    if (hasValidCoordinates(initialCoords)) {
      return { lat: initialCoords.lat, lng: initialCoords.lng };
    }

    return Map.DefaultConfig.center;
  }, [geoEvent?.lat, geoEvent?.lng, initialLat, initialLng]);
};
